import { gql } from '@apollo/client';

export const GET_EXIST_CONEXIONES_EN_CONTRATO = gql`
query GetExistConexionesEnContrato($idEvaluacion: Int!) {
    existConexionByIdEvaluacion(idEvaluacion: $idEvaluacion)
}
`;